module.exports = __webpack_public_path__ + "img/tips-luggage-icon.44de0205.svg";